import React from "react";
import {Table, Row, Col, Button, Form, FormGroup, FormControl, ControlLabel, Modal} from "react-bootstrap";
import Request from "request";
import {validateEmail} from "tools";
import CreateList from "./CreateList";
import {arrayChunk} from "../../../utils";

class TicketCreateEmail extends React.Component {
	state = {
		sheets: null,
		sheetIndex: 0,
		selectedColumn: 0,
		selectedRow: 0,
		emails: []
	};

	handleParseFile() {
		const {event} = this.props;
		const file = this.fileInputRef.files[0];

		var data = {file};

		Request.post(`/api/cp/event/${event.eventPassword}/ticket/parseFile`, data)
			.then(sheets => this.setState({sheets}));
			//.then(emails => this.setState({emails: emails.map(item => item.email)}));
	}
	handleSelectFile() {
		const {sheets, sheetIndex, selectedColumn, selectedRow} = this.state;
		const sheet = sheets[sheetIndex];

		const emails = sheet.slice(selectedRow).map(row => row[selectedColumn])
			.filter(email => !!email)
			.filter((value, index, self) => self.indexOf(value) === index)
		;

		this.setState({emails});
	}
	handleChangeEmail(oldEmail, newEmail) {
		var {emails} = this.state;
		const index = this.state.emails.findIndex(email => email === oldEmail);

		if(index >= 0) {
			emails[index] = newEmail;
			this.setState({emails});
		}
	}
	handleDeleteEmail(email) {
		var emails = this.state.emails.slice();
		const index = emails.findIndex(item => item === email);
		if(index >= 0) {
			emails.splice(index, 1);
			this.setState({emails});
		}
	}
	async handleCreate() {
		const {event, onCreate} = this.props;
		const {emails} = this.state;

		const emailsChunks = arrayChunk(emails, 1000);
		for (let i = 0; i < emailsChunks.length; i++) {
			let tickets = await Request.post(
				`/api/cp/event/${event.eventPassword}/ticket`,
				{email: emailsChunks[i]}
			);
			onCreate(tickets);
		}
	}

	UNSAFE_componentWillReceiveProps() {
		this.setState({emails: [], sheets: null, sheetIndex: 0, selectedRow: 0, selectedColumn: 0});
	}

	renderForm() {
		return (
			<section>
				<p>Загрузите Excel файл (xslx) со списком адресов электронной почты для создания и рассылки билетов.</p>
				<Form>
					<FormGroup>
						<FormControl type="file" inputRef={ref => this.fileInputRef = ref}
									 accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
						/>
					</FormGroup>
				</Form>
			</section>
		);
	}
	renderSheets() {
		const {sheets, sheetIndex, selectedColumn, selectedRow} = this.state;
		const sheet = sheets[sheetIndex];
		const maxRowsShow = 8;

		const sheetFiltered = sheet.slice(0, maxRowsShow);
		var columnCount = 0;
		sheet.forEach(row => Object.keys(row).forEach(index => columnCount = Math.max(columnCount, parseInt(index) + 1)));
		const columns = new Array(columnCount).fill(true).map((n, index) => baseConvert(index));

		function baseConvert(number, letters) {
			letters = letters || new Array(26).fill(true).map((n, index) => String.fromCharCode(65 + index));

			if(number >= 0 && number < letters.length) {
				return letters[number];
			}

			return baseConvert(parseInt(number/letters.length) - 1) + baseConvert(number%letters.length);
		}

		return (
			<section>
				<p>Выберите столбец и номер первой строки содержащие необходимые адреса электронной почты.</p>
				<Row>
					<Col xs={4}>
						<FormGroup>
							<ControlLabel>Лист</ControlLabel>
							<FormControl componentClass="select" value={sheetIndex} onChange={e => this.setState({sheetIndex: parseInt(e.target.value)})}>
								{sheets.map((sheet, index) => <option key={index} value={index}>{index + 1}</option>)}
							</FormControl>
						</FormGroup>
					</Col>
					<Col xs={4}>
						<FormGroup>
							<ControlLabel>Столбец</ControlLabel>
							<FormControl componentClass="select" value={selectedColumn} onChange={e => this.setState({selectedColumn: parseInt(e.target.value)})}>
								{columns.map((name, index) => <option key={index} value={index}>{name}</option>)}
							</FormControl>
						</FormGroup>
					</Col>
					<Col xs={4}>
						<FormGroup>
							<ControlLabel>Номер первой строки</ControlLabel>
							<FormControl componentClass="select" value={selectedRow} onChange={e => this.setState({selectedRow: parseInt(e.target.value)})}>
								{new Array(maxRowsShow).fill(true).map((n, index) => <option key={index} value={index}>{index + 1}</option>)}
							</FormControl>
						</FormGroup>
					</Col>
				</Row>

				<div className="sheetTableContainer">
					<Table>
						<thead>
						<tr>
							<th width="40" />
							{columns.map((name, index) => <th key={index}>{name}</th>)}
						</tr>
						</thead>
						<tbody>
						{sheetFiltered.map((row, rowIndex) =>
						<tr key={rowIndex} className={(rowIndex >= selectedRow ? 'selectedRow' : '') + (rowIndex === selectedRow ? ' selectedRowFirst' : '')}>
							<td>{rowIndex + 1}</td>
							{columns.map((name, colIndex) =>
								<td key={colIndex} className={colIndex === selectedColumn ? 'selectedColumn' : ''}>
									{row[colIndex] || null}
								</td>)}
						</tr>
						)}
						</tbody>
					</Table>
					<div className="sheetTableGradient" />
				</div>
			</section>
		);
	}
	renderEmails() {
		const {emails} = this.state;

		return (
			<CreateList emails={emails} onChange={this.handleChangeEmail.bind(this)} onDelete={this.handleDeleteEmail.bind(this)} />
		);
	}

	render() {
		const {onHide, show} = this.props;
		const {emails, sheets} = this.state;

		const invalidEmails = emails.filter(email => !validateEmail(email));

		var content;
		if(emails.length) {
			content = this.renderEmails();
		} else if(sheets) {
			content = this.renderSheets();
		} else {
			content = this.renderForm();
		}

		return (
			<Modal show={show} onHide={onHide} bsSize="large">
				<Modal.Header closeButton>
					<Modal.Title>Добавление билетов с рассылкой из файла</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{content}
				</Modal.Body>
				<Modal.Footer>
					{invalidEmails.length > 0 && <span style={{color: 'red'}}>Необходимо удалить или исправить некорректные адреса </span>}
					{emails.length ?
						<Button bsStyle="primary" onClick={this.handleCreate.bind(this)} disabled={emails.filter(e => !validateEmail(e)).length > 0}>Создать и разослать билеты</Button>
						: (sheets ?
								<Button bsStyle="primary" onClick={this.handleSelectFile.bind(this)}>Далее</Button>
								:
								<Button bsStyle="primary" onClick={this.handleParseFile.bind(this)}>Далее</Button>
						)
					}
					<Button onClick={onHide}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default TicketCreateEmail;
